/* assets/calendario.js — Sección "Calendario de eventos"
   Carga eventos desde un Google Apps Script y los organiza en un mini-calendario
   navegable por mes. Scopeado por instancia para soportar varias secciones. */

(function () {
  const MESES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  const MESES_CORTO = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
  const PLACEHOLDER_IMG = 'https://via.placeholder.com/640?text=Evento';
  const TITULOS_DESTACADOS = ['de cero a cien', 'certificacion hablar en publico'];
  const ARROW_SVG = '<svg class="btn-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const HEART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/></svg>';
  const CLOSE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  function normalizarTexto(str) {
    return String(str || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  function valorDestacado(valor) {
    return valor === true || ['true', 'si', 'sí', '1', 'x'].includes(normalizarTexto(valor));
  }

  function normalizarCategoria(valor) {
    const categoria = normalizarTexto(valor);
    if (['negocio', 'negocios', 'profesional', 'profesionales', 'business', 'career'].includes(categoria)) return 'business';
    if (['personal', 'persona', 'bienestar', 'mujer', 'mujeres'].includes(categoria)) return 'personal';
    return 'all';
  }

  function tituloDestacadoFallback(titulo) {
    const tituloNormalizado = normalizarTexto(titulo);
    return TITULOS_DESTACADOS.some(nombre => tituloNormalizado.includes(nombre));
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function initCalendario(root) {
    if (!root || root.dataset.calInit === 'true') return;
    root.dataset.calInit = 'true';

    const API_URL = root.dataset.apiUrl;
    const contenedor = root.querySelector('[data-cal="lista"]');
    const eventsGrid = root.querySelector('[data-cal="events-grid"]');
    const loader = root.querySelector('[data-cal="loader"]');
    const monthLabel = root.querySelector('[data-cal="month-label"]');
    const minicalTitle = root.querySelector('[data-cal="minical-title"]');
    const minicalGrid = root.querySelector('[data-cal="minical-grid"]');
    const railList = root.querySelector('[data-cal="rail-list"]');
    const railListTitle = root.querySelector('[data-cal="rail-list-title"]');
    const featuredBlock = root.querySelector('[data-cal="featured"]');
    const featuredTrack = root.querySelector('[data-cal="featured-track"]');
    const featuredSwiperElement = root.querySelector('[data-cal="featured-swiper"]');
    const featuredPrev = root.querySelector('[data-cal="featured-prev"]');
    const featuredNext = root.querySelector('[data-cal="featured-next"]');
    const featuredCounter = root.querySelector('[data-cal="featured-counter"]');
    const filterStatus = root.querySelector('[data-cal="filter-status"]');
    const audienceModal = document.getElementById(`cal-audience-modal-${root.dataset.uid}`);
    const audienceDialog = audienceModal ? audienceModal.querySelector('.cal-audience-modal__dialog') : null;
    const audienceTrigger = root.querySelector('[data-cal="open-audience-modal"]');

    if (!contenedor || !API_URL) return;

    let eventosGlobales = [];
    let featuredSwiper = null;
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth();
    let selectedDay = new Date().getDate();
    let activeTimeFilter = 'all';
    let activeCategoryFilter = 'all';
    let lastModalTrigger = null;

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    // ---------- AUXILIARES ----------
    function mostrarLoader(visible) {
      if (loader) loader.style.display = visible ? 'block' : 'none';
    }

    function parsearFecha(valor) {
      if (!valor) return new Date(NaN);
      const texto = String(valor).trim();
      const match = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (match) return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
      return new Date(valor);
    }

    function fechaLarga(ev) {
      const d = parsearFecha(ev.dateISO);
      return `${MESES[d.getMonth()].toUpperCase()} ${d.getDate().toString().padStart(2, '0')}, ${d.getFullYear()}`;
    }

    function etiquetaFechaEvento(item, dateISO) {
      const etiquetaDirecta = item['Fecha y Hora'] || item['Fecha/Hora'] || item['Horario'];
      if (etiquetaDirecta) return String(etiquetaDirecta);
      const inicio = item['Hora Inicio'] || item['Hora'];
      const fin = item['Hora Fin'];
      if (!inicio && !fin) return fechaLarga({ dateISO });
      const horario = fin ? `${inicio || ''} - ${fin}` : String(inicio);
      return `${fechaLarga({ dateISO })} · ${horario}`;
    }

    function categoriaCoincide(ev) {
      return activeCategoryFilter === 'all' || ev.category === activeCategoryFilter;
    }

    function eventosDelMes(year, month, aplicarCategoria = false) {
      return eventosGlobales
        .filter(ev => {
          const d = parsearFecha(ev.dateISO);
          return d.getFullYear() === year && d.getMonth() === month && (!aplicarCategoria || categoriaCoincide(ev));
        })
        .sort((a, b) => parsearFecha(a.dateISO) - parsearFecha(b.dateISO));
    }

    function inicioSemana(fecha) {
      const inicio = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
      const dia = inicio.getDay();
      const diferencia = dia === 0 ? 6 : dia - 1;
      inicio.setDate(inicio.getDate() - diferencia);
      return inicio.getTime();
    }

    function finSemana(fecha) {
      return inicioSemana(fecha) + (7 * 24 * 60 * 60 * 1000) - 1;
    }

    function eventoEnRango(ev) {
      const fecha = parsearFecha(ev.dateISO);
      const inicio = inicioDelDia(fecha);
      if (activeTimeFilter === 'today') return inicio === hoy.getTime();
      if (activeTimeFilter === 'week') return inicio >= inicioSemana(hoy) && inicio <= finSemana(hoy);
      if (activeTimeFilter === 'month') return fecha.getFullYear() === currentYear && fecha.getMonth() === currentMonth;
      return true;
    }

    function eventosParaGrid() {
      return eventosGlobales
        .filter(ev => categoriaCoincide(ev) && eventoEnRango(ev))
        .sort((a, b) => parsearFecha(a.dateISO) - parsearFecha(b.dateISO));
    }

    function eventosDelDiaSeleccionado() {
      return eventosDelMes(currentYear, currentMonth, true)
        .filter(ev => parsearFecha(ev.dateISO).getDate() === selectedDay);
    }

    function diaInicialDelMes(year, month) {
      if (year === hoy.getFullYear() && month === hoy.getMonth()) return hoy.getDate();
      const primerEvento = eventosDelMes(year, month)[0];
      return primerEvento ? parsearFecha(primerEvento.dateISO).getDate() : 1;
    }

    function inicioDelDia(fecha) {
      return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()).getTime();
    }

    function estadoEvento(ev) {
      const diaEvento = inicioDelDia(parsearFecha(ev.dateISO));
      const diaActual = hoy.getTime();

      if (diaEvento === diaActual) return 'today';
      return diaEvento < diaActual ? 'past' : 'upcoming';
    }

    function ordenarEventosParaGrid(eventos) {
      const prioridad = { today: 0, upcoming: 1, past: 2 };

      return [...eventos].sort((a, b) => {
        const estadoA = estadoEvento(a);
        const estadoB = estadoEvento(b);
        const diferenciaEstado = prioridad[estadoA] - prioridad[estadoB];

        if (diferenciaEstado !== 0) return diferenciaEstado;

        const fechaA = parsearFecha(a.dateISO).getTime();
        const fechaB = parsearFecha(b.dateISO).getTime();
        return estadoA === 'past' ? fechaB - fechaA : fechaA - fechaB;
      });
    }

    // ---------- PLANTILLAS ----------
    function badgeFecha(ev, estado) {
      const d = parsearFecha(ev.dateISO);
      const claseEstado = estado === 'past' ? ' media-fecha--past' : '';
      return `<span class="media-fecha${claseEstado}"><span class="media-fecha__dia">${d.getDate().toString().padStart(2, '0')}</span><span class="media-fecha__mes">${MESES_CORTO[d.getMonth()]}</span></span>`;
    }

    function safeEventUrl(url) {
      const value = String(url || '').trim();
      if (!value || /^javascript:/i.test(value)) return '#';
      return value;
    }

    function renderCard(ev, idx) {
      const d = parsearFecha(ev.dateISO);
      const estado = estadoEvento(ev);
      const esPasado = estado === 'past';
      const stateClass = esPasado ? ' event-card--past' : estado === 'today' ? ' event-card--today' : '';
      const image = ev.image || PLACEHOLDER_IMG;
      const primaryUrl = safeEventUrl(ev.link);
      const registerUrl = safeEventUrl(ev.registerLink);
      const primaryAttrs = primaryUrl === '#' ? ' aria-disabled="true" tabindex="-1"' : ' target="_blank" rel="noopener"';
      const registerAttrs = registerUrl === '#' ? ' aria-disabled="true" tabindex="-1"' : ' target="_blank" rel="noopener"';
      const eventDateLabel = ev.eventDateLabel || fechaLarga(ev);
      const price = ev.price ? `<span class="event-card__price">Costo: ${escapeHtml(ev.price)}</span>` : '';
      const registerAction = registerUrl !== '#'
        ? `<a href="${escapeHtml(registerUrl)}" class="event-card__action event-card__action--secondary"${registerAttrs}>Inscríbeme Ahora${ARROW_SVG}</a>`
        : '';

      return `
        <article class="event-card${stateClass}" style="--i:${idx}" data-index="${idx}" data-day="${d.getDate()}" data-event-state="${estado}" data-category="${escapeHtml(ev.category)}" id="ev-${root.dataset.uid}-${ev.id}">
          <img class="event-card__image" src="${escapeHtml(image)}" alt="${escapeHtml(ev.title)}" loading="lazy" width="1200" height="700" onerror="this.onerror=null;this.src='${PLACEHOLDER_IMG}'">
          <div class="event-card__date">
            <span class="event-card__date-month">${MESES_CORTO[d.getMonth()]}</span>
            <strong class="event-card__date-day">${d.getDate().toString().padStart(2, '0')}</strong>
          </div>
          <button class="event-card__favorite" type="button" aria-label="Agregar a favoritos" aria-pressed="false">${HEART_SVG}</button>
          <div class="event-card__closed">
            <button class="event-card__open-button" type="button" aria-expanded="false">Ver Más${ARROW_SVG}</button>
          </div>
          <div class="event-card__expanded">
            <button class="event-card__close" type="button" aria-label="Cerrar evento">${CLOSE_SVG}</button>
            <div class="event-card__meta">${price}<span class="event-card__time">${escapeHtml(eventDateLabel)}</span></div>
            <h2 class="event-card__title">${escapeHtml(ev.title)}</h2>
            <p class="event-card__description">${escapeHtml(ev.description)}</p>
            <div class="event-card__actions">
              <a href="${escapeHtml(primaryUrl)}" class="event-card__action"${primaryAttrs}>Ver Más${ARROW_SVG}</a>
              ${registerAction}
            </div>
          </div>
        </article>
      `;
    }

    function renderEmptyDia() {
      const nombreMes = MESES[currentMonth].toLowerCase();
      return `
        <div class="calendario-empty" role="status">
          <svg width="52" height="52" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="4.5" width="18" height="16" rx="3" stroke="currentColor" stroke-width="1.6"/><path d="M3 9h18M8 2.5v4M16 2.5v4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
          <p class="calendario-empty__title">No hay eventos el ${selectedDay} de ${nombreMes}</p>
          <p class="calendario-empty__msg">Selecciona otro día marcado en el calendario.</p>
        </div>
      `;
    }

    // ---------- RENDER MINI CALENDARIO ----------
    function renderMiniCal() {
      const nombreMes = `${MESES[currentMonth]} ${currentYear}`;
      if (minicalTitle) minicalTitle.textContent = nombreMes;
      if (monthLabel) monthLabel.textContent = nombreMes;
      if (!minicalGrid) return;

      const eventos = eventosDelMes(currentYear, currentMonth, true);
      const diasConEventos = new Set(eventos.map(ev => parsearFecha(ev.dateISO).getDate()));

      const primerDia = new Date(currentYear, currentMonth, 1).getDay();
      const offset = (primerDia + 6) % 7;
      const diasEnMes = new Date(currentYear, currentMonth + 1, 0).getDate();

      let celdas = '';
      for (let i = 0; i < offset; i++) {
        celdas += '<span class="minical-cell minical-cell--empty" aria-hidden="true"></span>';
      }
      for (let dia = 1; dia <= diasEnMes; dia++) {
        const esHoy = currentYear === hoy.getFullYear() && currentMonth === hoy.getMonth() && dia === hoy.getDate();
        const esSeleccionado = dia === selectedDay;
        const tieneEventos = diasConEventos.has(dia);
        const clases = ['minical-cell'];
        if (esHoy) clases.push('minical-cell--today');
        if (tieneEventos) clases.push('minical-cell--event');
        if (esSeleccionado) clases.push('minical-cell--selected');

        const estadoEventos = tieneEventos ? ', con eventos' : ', sin eventos';
        celdas += `<button type="button" class="${clases.join(' ')}" data-day="${dia}" aria-label="${dia} de ${MESES[currentMonth]}${estadoEventos}" aria-pressed="${esSeleccionado ? 'true' : 'false'}"${esHoy ? ' aria-current="date"' : ''}><span>${dia}</span></button>`;
      }
      minicalGrid.innerHTML = celdas;
    }

    // ---------- RENDER LISTA RAIL ----------
    function renderRailList() {
      const eventos = ordenarEventosParaGrid(eventosDelMes(currentYear, currentMonth, true));
      if (railListTitle) {
        railListTitle.textContent = 'Próximos Eventos';
      }
      if (!railList) return;
      if (!eventos.length) {
        railList.innerHTML = '';
        return;
      }
      railList.innerHTML = eventos.map(ev => {
        const d = parsearFecha(ev.dateISO);
        const esPasado = estadoEvento(ev) === 'past';
        return `
          <li>
            <button type="button" class="rail-item${esPasado ? ' rail-item--past' : ''}" data-target="ev-${root.dataset.uid}-${ev.id}">
              <span class="rail-item__day">${d.getDate().toString().padStart(2, '0')}<small>${MESES_CORTO[d.getMonth()]}</small></span>
              <span class="rail-item__title">${escapeHtml(ev.title)}</span>
            </button>
          </li>
        `;
      }).join('');
    }

    // ---------- CARRUSEL DESTACADOS ----------
    function eventosDestacados() {
      return eventosGlobales
        .filter(ev => ev.featured && estadoEvento(ev) !== 'past')
        .sort((a, b) => parsearFecha(a.dateISO) - parsearFecha(b.dateISO))
        .slice(0, 2);
    }

    function actualizarContadorDestacados(index, total) {
      if (featuredCounter) featuredCounter.textContent = `${index + 1} / ${total}`;
    }

    function renderFeatured() {
      if (!featuredBlock || !featuredTrack || !featuredSwiperElement) return;

      const eventos = eventosDestacados();
      if (featuredSwiper) {
        featuredSwiper.destroy(true, true);
        featuredSwiper = null;
      }

      if (!eventos.length) {
        featuredBlock.hidden = true;
        featuredTrack.innerHTML = '';
        return;
      }

      featuredTrack.innerHTML = eventos.map(ev => {
        const d = parsearFecha(ev.dateISO);
        return `
          <div class="swiper-slide rail-featured__slide">
            <button
              class="rail-featured__event"
              type="button"
              data-featured-event-id="${ev.id}"
              aria-label="Ver ${escapeHtml(ev.title)} en el calendario"
            >
              <span class="rail-featured__date">
                <strong>${d.getDate().toString().padStart(2, '0')}</strong>
                <small>${MESES_CORTO[d.getMonth()]}</small>
              </span>
              <span class="rail-featured__copy">
                <small>Destacado</small>
                <span>${escapeHtml(ev.title)}</span>
              </span>
              <svg class="rail-featured__event-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </button>
          </div>
        `;
      }).join('');

      featuredBlock.hidden = false;
      actualizarContadorDestacados(0, eventos.length);

      if (typeof window.Swiper !== 'function') {
        featuredBlock.classList.add('is-static');
        return;
      }

      featuredBlock.classList.remove('is-static');
      featuredSwiper = new window.Swiper(featuredSwiperElement, {
        slidesPerView: 1,
        spaceBetween: 12,
        speed: 320,
        loop: false,
        autoHeight: false,
        grabCursor: eventos.length > 1,
        watchOverflow: true,
        allowTouchMove: eventos.length > 1,
        navigation: {
          prevEl: featuredPrev,
          nextEl: featuredNext
        },
        a11y: {
          enabled: true,
          prevSlideMessage: 'Evento destacado anterior',
          nextSlideMessage: 'Evento destacado siguiente'
        },
        on: {
          init(swiper) {
            actualizarContadorDestacados(swiper.realIndex, eventos.length);
          },
          slideChange(swiper) {
            actualizarContadorDestacados(swiper.realIndex, eventos.length);
          }
        }
      });
    }

    function renderEmptyMes() {
      return `
        <div class="calendario-empty" role="status">
          <svg width="52" height="52" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="4.5" width="18" height="16" rx="3" stroke="currentColor" stroke-width="1.6"/><path d="M3 9h18M8 2.5v4M16 2.5v4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
          <p class="calendario-empty__title">No encontramos eventos con estos filtros</p>
          <p class="calendario-empty__msg">Prueba con otra fecha o categoría para ver más opciones.</p>
          <div class="calendario-empty__acciones">
            <button type="button" class="btn-ghost" data-reset-filters>Ver todos los eventos</button>
          </div>
        </div>
      `;
    }

    function actualizarEstadoFiltros() {
      root.querySelectorAll('[data-filter-time]').forEach(btn => {
        const activo = btn.dataset.filterTime === activeTimeFilter;
        btn.classList.toggle('is-active', activo);
        btn.setAttribute('aria-pressed', activo ? 'true' : 'false');
      });
      root.querySelectorAll('[data-filter-category]').forEach(btn => {
        const activo = btn.dataset.filterCategory === activeCategoryFilter;
        btn.classList.toggle('is-active', activo);
        btn.setAttribute('aria-pressed', activo ? 'true' : 'false');
      });
      if (filterStatus) {
        const total = eventosParaGrid().length;
        const categoria = activeCategoryFilter === 'all' ? '' : ` de ${activeCategoryFilter === 'business' ? 'Negocios' : 'Personal'}`;
        const rango = activeTimeFilter === 'all' ? 'todos los eventos' : activeTimeFilter === 'month' ? `eventos de ${MESES[currentMonth].toLowerCase()}` : activeTimeFilter === 'week' ? 'eventos de esta semana' : 'eventos de hoy';
        filterStatus.textContent = `${total} ${total === 1 ? 'evento' : 'eventos'}${categoria} · ${rango}`;
      }
    }

    function renderGridShell() {
      return `
        <div class="events-wrapper" data-cal="events-wrapper">
          <div id="eventsGrid-${escapeHtml(root.dataset.uid)}" class="events-grid" data-cal="events-grid" aria-live="polite"></div>
        </div>
      `;
    }

    function renderGrid() {
      const eventos = ordenarEventosParaGrid(eventosParaGrid());
      if (window.CalendarioGrid) window.CalendarioGrid.reset(root);
      actualizarEstadoFiltros();
      if (!eventos.length) {
        contenedor.innerHTML = renderEmptyMes();
        return;
      }
      let grid = root.querySelector('[data-cal="events-grid"]');
      if (!grid) {
        contenedor.innerHTML = renderGridShell();
        grid = root.querySelector('[data-cal="events-grid"]');
      }
      if (!grid) return;
      grid.innerHTML = eventos.map(renderCard).join('');
      if (window.CalendarioGrid) window.CalendarioGrid.mount(root);
    }

    function render() {
      renderMiniCal();
      renderRailList();
      renderGrid();
    }

    // ---------- NAVEGACIÓN ----------
    function cambiarMes(delta) {
      activeTimeFilter = 'month';
      const d = new Date(currentYear, currentMonth + delta, 1);
      currentYear = d.getFullYear();
      currentMonth = d.getMonth();
      selectedDay = diaInicialDelMes(currentYear, currentMonth);
      render();
    }

    function irAMes(year, month, usarFiltroMes = true) {
      if (usarFiltroMes) activeTimeFilter = 'month';
      currentYear = year;
      currentMonth = month;
      selectedDay = diaInicialDelMes(year, month);
      render();
    }

    function scrollAEvento(id) {
      const el = root.querySelector('#' + CSS.escape(id));
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.classList.add('evento-card--flash');
      setTimeout(() => el.classList.remove('evento-card--flash'), 1400);
    }

    function scrollAlPrimeroDelDia(dia) {
      const eventos = eventosDelMes(currentYear, currentMonth, true);
      const ev = eventos.find(e => parsearFecha(e.dateISO).getDate() === dia);
      if (ev) scrollAEvento('ev-' + root.dataset.uid + '-' + ev.id);
    }

    function abrirModalAudiencia() {
      if (!audienceModal) return;
      lastModalTrigger = document.activeElement;
      audienceModal.hidden = false;
      document.body.classList.add('cal-modal-open');
      requestAnimationFrame(() => {
        if (audienceDialog) audienceDialog.focus();
      });
    }

    function cerrarModalAudiencia() {
      if (!audienceModal) return;
      audienceModal.hidden = true;
      document.body.classList.remove('cal-modal-open');
      if (lastModalTrigger && typeof lastModalTrigger.focus === 'function') lastModalTrigger.focus();
    }

    function aplicarFiltros(timeFilter, categoryFilter) {
      activeTimeFilter = timeFilter || 'all';
      activeCategoryFilter = categoryFilter || 'all';
      if (activeTimeFilter === 'month') {
        currentYear = hoy.getFullYear();
        currentMonth = hoy.getMonth();
        selectedDay = hoy.getDate();
      }
      render();
    }

    function wireEventos() {
      root.querySelectorAll('[data-nav]').forEach(btn => {
        btn.addEventListener('click', () => {
          const nav = btn.getAttribute('data-nav');
          if (nav === 'prev') cambiarMes(-1);
          else if (nav === 'next') cambiarMes(1);
          else if (nav === 'hoy') irAMes(new Date().getFullYear(), new Date().getMonth());
        });
      });

      root.querySelectorAll('[data-filter-time]').forEach(btn => {
        btn.addEventListener('click', () => aplicarFiltros(btn.dataset.filterTime, activeCategoryFilter));
      });
      root.querySelectorAll('[data-filter-category]').forEach(btn => {
        btn.addEventListener('click', () => {
          const categoria = activeCategoryFilter === btn.dataset.filterCategory ? 'all' : btn.dataset.filterCategory;
          aplicarFiltros(activeTimeFilter, categoria);
        });
      });

      if (audienceTrigger) audienceTrigger.addEventListener('click', abrirModalAudiencia);
      if (audienceModal) {
        audienceModal.querySelectorAll('[data-cal="close-audience-modal"]').forEach(btn => btn.addEventListener('click', cerrarModalAudiencia));
        audienceModal.querySelectorAll('[data-modal-category]').forEach(btn => {
          btn.addEventListener('click', () => {
            aplicarFiltros('all', btn.dataset.modalCategory);
            cerrarModalAudiencia();
          });
        });
      }
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && audienceModal && !audienceModal.hidden) cerrarModalAudiencia();
      });

      if (minicalGrid) {
        minicalGrid.addEventListener('click', e => {
          const cell = e.target.closest('.minical-cell--event');
          if (cell && cell.dataset.day) {
            selectedDay = parseInt(cell.dataset.day, 10);
            scrollAlPrimeroDelDia(selectedDay);
            renderMiniCal();
          }
        });
      }

      if (railList) {
        railList.addEventListener('click', e => {
          const item = e.target.closest('.rail-item');
          if (item && item.dataset.target) scrollAEvento(item.dataset.target);
        });
      }

      if (featuredBlock) {
        featuredBlock.addEventListener('click', e => {
          const item = e.target.closest('[data-featured-event-id]');
          if (!item) return;

          const eventoId = Number(item.dataset.featuredEventId);
          const evento = eventosGlobales.find(ev => ev.id === eventoId);
          if (!evento) return;

          const fecha = parsearFecha(evento.dateISO);
          irAMes(fecha.getFullYear(), fecha.getMonth());
          requestAnimationFrame(() => scrollAEvento(`ev-${root.dataset.uid}-${evento.id}`));
        });
      }

      contenedor.addEventListener('click', e => {
        const reset = e.target.closest('[data-reset-filters]');
        if (reset) aplicarFiltros('all', 'all');
        const goto = e.target.closest('[data-goto]');
        if (goto) {
          const [y, m] = goto.getAttribute('data-goto').split('-').map(Number);
          irAMes(y, m);
        }
      });
    }

    // ---------- INICIALIZACIÓN ----------
    function inicializar(eventos) {
      eventosGlobales = eventos;
      mostrarLoader(false);

      const proximo = eventos
        .filter(ev => estadoEvento(ev) !== 'past')
        .sort((a, b) => parsearFecha(a.dateISO) - parsearFecha(b.dateISO))[0];
      let base;
      if (proximo) base = parsearFecha(proximo.dateISO);
      else if (eventos.length) base = parsearFecha(eventos[eventos.length - 1].dateISO);
      else base = new Date();
      currentYear = base.getFullYear();
      currentMonth = base.getMonth();
      selectedDay = diaInicialDelMes(currentYear, currentMonth);

      renderFeatured();
      render();
      wireEventos();
    }

    mostrarLoader(true);

    fetch(API_URL)
      .then(response => {
        if (!response.ok) throw new Error(`Error en la API: ${response.status}`);
        return response.json();
      })
      .then(data => {
        if (!Array.isArray(data) || data.length === 0) throw new Error('No hay eventos disponibles');

        const eventosProcessados = data
          .map((item, idx) => {
            const categoriaRaw = item['Categoría'] || item['Categoria'] || item['Tipo de evento'] || item['Tipo'] || item['Persona'] || item['Audiencia'];
            return {
              id: idx,
              dateISO: item['Fecha'],
              title: item['Título'],
              description: item['Descripción'],
              image: item['Imagen URL'],
              link: item['Enlace'],
              registerLink: item['Enlace Registro'] || item['Enlace Inscripción'] || item['Registro'] || item['URL Registro'],
              price: item['Precio'] || item['Costo'] || '',
              eventDateLabel: etiquetaFechaEvento(item, item['Fecha']),
              category: normalizarCategoria(categoriaRaw),
              audience: item['Persona'] || item['Audiencia'] || '',
              featured: valorDestacado(item['Destacado']) || tituloDestacadoFallback(item['Título'])
            };
          })
          .filter(ev => ev.dateISO)
          .sort((a, b) => parsearFecha(a.dateISO) - parsearFecha(b.dateISO));

        inicializar(eventosProcessados);
      })
      .catch(error => {
        console.error('Error cargando eventos:', error);
        mostrarLoader(false);
        contenedor.innerHTML = `
          <div class="calendario-error" role="alert">
            <p class="calendario-error__title">No pudimos cargar los eventos</p>
            <p class="calendario-error__msg">${escapeHtml(error.message)}</p>
            <p class="calendario-error__hint">Recarga la página para intentarlo de nuevo.</p>
          </div>
        `;
      });
  }

  function initAll() {
    document.querySelectorAll('[data-cal="root"]').forEach(initCalendario);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
